import { BookOpen, Calculator, Receipt, FileSignature, Globe2, Lightbulb, GraduationCap, Sparkles, Video, Mic, Users, Tv } from "lucide-react";
import { useT } from "@/lib/i18n";
import SEO from "@/components/SEO";

const TOPICS = [
  { icon: BookOpen, key: "bookkeeping" },
  { icon: Calculator, key: "tax" },
  { icon: Receipt, key: "sales_tax" },
  { icon: FileSignature, key: "itin" },
  { icon: FileSignature, key: "notary" },
  { icon: Globe2, key: "spanish_biz" },
  { icon: Lightbulb, key: "personal" },
  { icon: Sparkles, key: "ai" },
];

const MEDIA = [
  { icon: Video, key: "reels" },
  { icon: Tv, key: "longform" },
  { icon: Mic, key: "podcast" },
  { icon: Users, key: "community" },
];

const Resources = () => {
  const tt = useT();
  return (
    <div className="bg-white">
      <SEO
        title="Resources & Education — Roman Numerals III | Bilingual Financial Education"
        description="Free bilingual resources on bookkeeping, taxes, sales tax, ITIN, notary, and Spanish business education from Roman Numerals III in Jacksonville, FL."
        path="/resources"
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Resources", path: "/resources" }]}
      />
      <section className="bg-[#FDFBF7]">
        <div className="rn3-container py-16">
          <div className="rn3-eyebrow flex items-center gap-2"><GraduationCap className="w-4 h-4" /> {tt("resources.eyebrow")}</div>
          <h1 className="font-serif-display text-5xl mt-3">{tt("resources.h1")}</h1>
          <p className="mt-4 max-w-xl text-[#404040]">{tt("resources.intro")}</p>
        </div>
      </section>

      <section className="rn3-section">
        <div className="rn3-container">
          <h2 className="font-serif-display text-3xl">{tt("resources.topics_h2")}</h2>
          <div className="border-t border-[#C4A252] w-10 mt-3 mb-8" />
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {TOPICS.map((t) => (
              <div key={t.key} className="rn3-card" data-testid={`topic-${t.key}`}>
                <t.icon className="w-7 h-7 text-[#C4A252]" />
                <h3 className="font-serif-display text-xl mt-3">{tt(`resources.topic.${t.key}.title`)}</h3>
                <div className="border-t border-[#C4A252] w-8 mt-2 mb-3" />
                <p className="text-sm text-[#404040] leading-relaxed">{tt(`resources.topic.${t.key}.body`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#F3EFE9]">
        <div className="rn3-container py-16">
          <h2 className="font-serif-display text-3xl">{tt("resources.media_h2")}</h2>
          <div className="border-t border-[#C4A252] w-10 mt-3 mb-8" />
          <div className="grid md:grid-cols-4 gap-6">
            {MEDIA.map((m) => (
              <div key={m.key} className="bg-white border border-[#E5E5E5] p-6" data-testid={`media-${m.key}`}>
                <m.icon className="w-6 h-6 text-[#8B1C22]" />
                <div className="font-serif-display text-xl mt-3">{tt(`resources.media.${m.key}.label`)}</div>
                <p className="text-sm text-[#737373] mt-2">{tt(`resources.media.${m.key}.body`)}</p>
                <div className="mt-4 text-xs uppercase tracking-widest text-[#C4A252]">{tt("resources.placeholder")}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Resources;
